export default __webpack_public_path__ + "static/media/TriviaPro.e2cd7e61.JPG";